import Vue from 'vue'

const setFiles = (state, { files }) => {
  state.files = files;
};

const setCountFiles = (state, countFiles) => {
  state.countFiles = countFiles;
};

const updateStatusFilesToReq = (state, listFiles) => {
  listFiles.forEach(cfile => {
    const index = state.files.findIndex(f => f.id === cfile.id);
    if (index !== -1) {
      // reactivo
      Vue.set(state.files[index], 'status', 'req');
    }
  });
};

export default {
  setFiles,
  setCountFiles,
  updateStatusFilesToReq
};



// WEBPACK FOOTER //
// ./src/store/modules/files/mutations.js